import ISensorDataState from "../models/ISensorDataState";

export const initialState: ISensorDataState = {
    sensorDataList: {
        datas: { IAQSensorData: [] },
        error: null,
        success: false,
        loading: false
    },

    sensorData: {
        data: null,
        error: null,
        loading: false
    },
};
